<template>
  <div>
    <section-definition :title="page.title" :extraOptions="page.options" :icon="page.icon" :breadcrumbs="page.breadcrumbs"
      :addNewData="page.addnew" :exportOptions="page.exportOptions" @openFilter="filterClick"
      @refreshPage="refreshThisPage" @addNew="AddNewRule" :style="styleObject">
    </section-definition>
    <loader v-if="page.loading"></loader>
    <v-container v-else fluid grid-list-xl page>
      <v-data-table :headers="headers" :items="categoryData" class="elevation-1 fixed-layout"
        :pagination.sync="pagination" :total-items="pagecount" :loading="tableLoading" :rows-per-page-items="[10]">
        <template v-slot:no-data style="text-align: center">
          <div style="text-align: center">No Data Available</div>
        </template>
        <template v-slot:items="props">
          <td class="checkEmpty p0">{{ props.item.name }}</td>
          <td class="checkEmpty p0">{{ props.item.description }}</td>
          <!-- <td class="checkEmpty p0">{{ props.item.is_active }}</td> -->
          <td class="checkEmpty p0">  
            <template v-if="props.item.status == '0' ">Active</template>
            <template v-else>Inactive</template>
          </td>
          <td class="text-xs-center checkEmpty p0">
            <v-icon color="blue" small class="mr-4" v-if="page.canedit" @click="editItem(props.item)">edit</v-icon>
            <v-icon color="red" small class="mr-4" v-if="page.candelete" @click="deleteItem(props.item)">delete</v-icon></td>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog persistent v-model="DeleteRowdata" max-width="500px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title>
            <span class="headline">Delete Category</span>
          </v-card-title>
        </v-toolbar>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-card-text>{{ deletemsg }}</v-card-text>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="light" flat @click="closedelete()">Cancel</v-btn>
          <v-btn color="primary" @click="savedelete()">Yes, Delete !</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template>
      <v-dialog persistent :value="page.isAddCategory" scrollable max-width="500px">
        <v-card>
          <v-toolbar dark color="primary">
            <v-card-title>
              <span class="headline">Create Category</span>
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="meetingtitle" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="addCategory.payload.name" required label="Category Name" type="text"
                      :rules="[(v) => !!v || 'Meeting Title is required']"></v-text-field>
                  </v-flex>
              
                  <v-flex xs12>
                    <v-text-field v-model="addCategory.payload.description" required label="Description" type="text"
                      :rules="[(v) => !!v || 'Description is required']"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="modal-footer--sticky">
            <v-spacer></v-spacer>
            <v-btn color="light" flat @click="closeCategory()">Close</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="saveAddCategory()">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog persistent :value="page.isEditPausecode" scrollable max-width="500px">
        <v-card>
          <v-toolbar dark color="primary">
            <v-card-title>
              <span class="headline">Update Category</span>
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="update" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="editCategory.name" required label="Category name" type="text"
                      :rules="[(v) => !!v || 'Category name is required']"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="editCategory.description" required label="Description" type="text"
                      :rules="[(v) => !!v || 'Description is required']"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select v-model="editCategory.is_active" required label="Status" :items="is_active"
                      :rules="[(v) => !!v || 'Status is required']"></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="modal-footer--sticky">
            <v-spacer></v-spacer>
            <v-btn color="light" flat @click="closeEditRules()">Close</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="saveEditRules()">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-navigation-drawer fixed disable-resize-watcher right :value="page.isFilterOpen">
      <v-toolbar small color="secondary" style="color: white">
        <v-toolbar-title>Filter</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="white" @click="page.isFilterOpen = false">
          <i class="fas fa-close"></i>
        </v-btn>
      </v-toolbar>
      <div class="flex-column justify-sb height-100-exclude-toolbar overflow-auto">
        <v-container class="sidenavContainer">
          <div class="autocompleteDiv">
           <v-select
                v-model="filter.payload.title"
                label="Title"
                :items="this.newArray"
              ></v-select>
             <v-select
                v-model="filter.payload.is_active"
                label="Status"
                :items="status"
              ></v-select>
          </div>
        </v-container>
        <v-container row class="sidenavFooter">
          <v-btn flat @click="reset()">Reset</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="getDataFromApi()">Filter</v-btn>
        </v-container>
      </div>
    </v-navigation-drawer>
    <v-snackbar v-model="snackbar.show" :bottom="true" :right="true" :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn color="pink" flat @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="isProcessing" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import loader from "@/components/Widgets/loader";
//import api from "@/utils/axios-util";
import { mapGetters } from "vuex";
export default {
  components: {
    loader,
  },

  data() {
    return {
      valid: true,
      styleObject: {
        height: "80px",
        "margin-top": "-8px",
      },
      page: {
        title: "Category",
        icon: "fa-list-alt fa-2x",
        loading: false,
        isAddCategory: false,
        isFilterOpen: false,
        playingRecord: false,
        breadcrumbs: [],
        exportOptions: [],
        options: { filter: true, refresh: true, autoCompletePC: true },
        addnew: [],
        isEditPausecode: false,
        temp: { key: "addcategory", label: "Add Category" },
        candelete: false,
        timeModal: false,
        timeModal1: false,
        canedit: false,
      },
      pagecount: 0,
      headers: [
        {
          text: "Name",
          align: "left",
          class: "p0",
          sortable: false,
          value: "name",
        },
        {
          text: "Description",
          align: "left",
          class: "p0",
          sortable: false,
          value: "description",
        },
        {
          text: "Status",
          align: "left",
          class: "p0",
          sortable: false,
          value: "status",
        },
        {
          text: "Action",
          align: "left",
          class: "p0",
          sortable: false,
          value: "action",
        },

      ],
      categoryData: [],
      //pagecount: 0,
      pagination: {
        rowsPerPage: 10,
        page:1
      },
      snackbar: {
        show: false,
        timeout: 6000,
        text: "",
      },
      DeleteRowdata: false,
      showRowData: false,
      DataRow: false,
      tableLoading: false,
      crmdomain: "",
      filtervalue: [],
      newArray: [],

      filter: {
        payload: {
          title:"",
          is_active:""
        },
        options: {
          status: ["Active", "Inactive"],
        },
        isLoading: false,
      },
          status: ["Active", "Inactive"],

      isProcessing: false,
      call_status: [],
      editCategory: {
        id: "",
        name:"",
        description: "",
        is_active: ""
      },
      addCategory: {
        valid: false,
        payload: {
          name:"",
          description: "",
          },
      },
      is_active: ["Active", "Inactive"],
      deletemsg:'',
      deleted_data:{}
    };
  },
  methods: {
    refreshThisPage: function () {
      var scope = this;
      scope.page.loading = true;
      scope.pagination.page = 1;
      scope.getDataFromApi();
    },
    filterClick: function () {
      this.page.isFilterOpen = true;
    },

    reset() {
      var scope = this;
      scope.getDataFromApi();
      this.page.isFilterOpen = true;
    },
   
    getDataFromApi() {
      var scope = this;
      scope.tableLoading = true;

      this.page.isFilterOpen = false;
      let take = this.pagination.rowsPerPage;
      let skip;
      if (this.pagination.page === 1) {
        skip = 0;
      } else {
        skip = this.pagination.rowsPerPage * (this.pagination.page - 1);
      }
      scope.filter.payload["skip"] = skip;
      scope.filter.payload["take"] = take;
      scope.skip = skip;
      this.$store
        .dispatch("fetchCategoryData", scope.filter.payload)
        .then((response) => {
          console.log(response,"sdjaa");
          this.pagecount = response.count;
          scope.tableLoading = false;
          scope.page.loading = false;
          var datas = response.data.data;
          scope.newArray = datas.map((element) => element.name);
          scope.categoryData = datas;
        })
        .catch(function (error) {
          scope.page.isAddCategory = false;
          scope.showSnackBar("error" + error);
          this.page.isEditPausecode = false;
        });
    },
    AddNewRule: function () {
      //var scope = this;
      this.page.isAddCategory = true;
    },
    closeEditRules: function () {
      this.page.isEditPausecode = false;
    },
    closeCategory: function () {
      this.page.isAddCategory = false;
      this.$refs.meetingtitle.reset();
    },
    saveEditRules() {
      var scope = this;
      if(this.editCategory.is_active == "Active"){
          this.editCategory.is_active = "0"
      }else{
          this.editCategory.is_active = "1"

      }
      scope.$store
        .dispatch("removeCategory", scope.editCategory)
        .then(() => {
          scope.page.isAddCategory = false;
          scope.showSnackBar("Updated Successfully");
          this.getDataFromApi();
          this.page.isEditPausecode = false;
        })
        .catch(function (error) {
          scope.page.isAddCategory = false;
          scope.showSnackBar("error" + error);
          this.page.isEditPausecode = false;
        });
      this.getDataFromApi();
    },
    saveAddCategory() {
      var scope = this;
      scope.$store
        .dispatch("createCategory", scope.addCategory.payload)
        .then(() => {
          scope.page.isAddCategory = false;

          scope.showSnackBar("Created Successfully");
          this.getDataFromApi();
          this.$refs.meetingtitle.reset();
        })
        .catch(function (error) {
          scope.page.isAddCategory = false;
          if (error.response && error.response.status === 409) { 
            scope.showSnackBar("The meeting title already exists");
          } 
        });
      this.getDataFromApi();
    },
    showSnackBar(message) {
      let scope = this;
      scope.snackbar.text = message;
      scope.snackbar.show = true;
      setTimeout(() => {
        scope.snackbar.text = "";
      }, scope.snackbar.timeout);
    },
    deleteItem(data) {   
       let scope = this
      scope.delete_id = data.id;
      scope.deletemsg = `Are you Sure to delete this Category?`
      this.DeleteRowdata = true;
    },
    editItem(item) {
      this.page.isEditPausecode = true;
      this.editCategory.id = item.id;
      this.editCategory.name = item.name;
      this.editCategory.description = item.description;
      this.editCategory.status = item.is_active
      

      if (item.is_active === "1") {
        this.editCategory.is_active = "Active";
      } else {
        this.editCategory.is_active = "Inactive";
      }
    },
    savedelete() {
      let scope = this;
      scope.isProcessing = true;
      scope.filtervalue = [];
      this.$store
        .dispatch("deleteMeetingTitle", scope.delete_id)
        .then((response) => {
          scope.isProcessing = false;
          if (response.data.message == "success") {
            scope.getDataFromApi();
            scope.showSnackBar("Meeting Title Deleted");
          } else {
            scope.showSnackBar("Error! Unable Delete Meeting Title");
          }
        })
        .catch(() => {
          scope.isProcessing = false;
          scope.showSnackBar("Error! Unable Delete list");
        });
      this.closedelete();
    },
    closedelete() {
      this.DeleteRowdata = false;
    },
    closeShow() {
      this.showRowData = false;
    },
  },
  computed: {
    ...mapGetters(["CallFlow"]),
  },
  mounted() {
    let scope = this;
    this.page.loading = false;
    setTimeout(
      function () {
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:pausecode:create"
          ) !== -1
        ) {
          scope.page.addnew = [{ label: "Add Category" }];
        }
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:pausecode:edit"
          ) !== -1
        ) {
          scope.page.canedit = true;
        }
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:pausecode:delete"
          ) !== -1
        ) {
          scope.page.candelete = true;
        }
      }.bind(scope),
      1
    );
    const project_config = JSON.parse(localStorage.projectConfig);
    this.crmdomain = project_config.projects[0].config[0].crm_domain;
    this.getDataFromApi();
    this.filterFieldOptions();
  },
  watch: {
    pagination: {
      handler() {
        if (this.pagination.page > 1 || this.skip >= 10) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.mr-4 {
  text-align: start;
}

.file-dummy {
  width: 100%;
  padding: 30px;
  border: 2px dashed;
  text-align: center;
  transition: #2196f333 0.3s ease-in-out;
  cursor: pointer;
  font-weight: bold;
}
</style>